import { render, staticRenderFns } from "./mrp-xqy-add.vue?vue&type=template&id=cae853a4&scoped=true"
import script from "./mrp-xqy-add.vue?vue&type=script&lang=js"
export * from "./mrp-xqy-add.vue?vue&type=script&lang=js"
import style0 from "./mrp-xqy-add.vue?vue&type=style&index=0&id=cae853a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae853a4",
  null
  
)

export default component.exports